import { setValue } from "./skyward.ui.controls";
// for $.fn.selectRange
import { } from "./skyward.base.extensions";

// This has been split out into a separate file to avoid circular dependencies with controls.ts
export function insertTextToken(controlToUpdate: JQuery<HTMLInputElement>, token: string | undefined | null, addSpace?: boolean, supressChangeEvent?: boolean)
{
    controlToUpdate.trigger("focus"); // edge needs focus on the element before using selectionStart and selectionEnd
    var originalValue = String(controlToUpdate.val());

    var selectionStart = controlToUpdate.prop("selectionStart");
    var selectionEnd = controlToUpdate.prop("selectionEnd") || selectionStart;
    var textBefore = originalValue.slice(0, selectionStart);
    var textAfter = originalValue.slice(selectionEnd);

    if (token === undefined || token === null)
    {
        token = "";
    }

    if (addSpace)
    {
        var lastTextBeforeChar = textBefore.charAt(textBefore.length - 1);
        var firstTextAfterChar = textAfter.charAt(0);
        if (lastTextBeforeChar !== " " && textBefore.length > 0)
        {
            token = " " + token;
        }

        if (firstTextAfterChar !== " " && textAfter.length > 0)
        {
            token = token += " ";
        }
    }
    var newCursorPosition = selectionStart + token.length;
    var newValue = textBefore + token + textAfter;
    setValue(controlToUpdate, newValue, supressChangeEvent);
    controlToUpdate.selectRange(newCursorPosition);
};
